const queryKeyMap = {
  batch: (params?: object) =>
    ['batch', params].filter((item) => item !== undefined),
};

export const invalidateBatchListMap = {
  batchList: () => [queryKeyMap.batch()],
};
